import 'core-js/stable';
import 'regenerator-runtime/runtime';

// https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob for ie and mobile
if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
            var canvas = this;
            setTimeout(function () {
                var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
                    len = binStr.length,
                    arr = new Uint8Array(len);

                for (var i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                }

                callback(new Blob([arr], { type: type || 'image/png' }));
            });
        }
    });
}

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

// closest polifill
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
if (!Element.prototype.closest) {
    Element.prototype.closest = function (css) {
        var node = this;
        while (node) {
            if (node.matches(css)) {
                return node;
            } else {
                node = node.parentElement; // does not work for IE11 HTMLUnknownElement
                //				node = node.parentNode;
            }
            return null;
        }
    };
}
